import { createFileRoute } from '@tanstack/react-router'
import { NotificationsScreen } from '../features/notifications'

export const Route = createFileRoute('/notifications')({ component: NotificationsScreen })
